// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__efd2a","description":"PatientConsentPreview_description__2Mqq2"};